"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimberService = void 0;
var timber_1 = require("@itero/timber");
var enums_1 = require("@itero/timber/enums");
var TimberService = /** @class */ (function () {
    function TimberService(loggingEndpoint) {
        var config = {
            appId: 'itero-event-bus',
            appenderTypes: [enums_1.AppenderType.Remote],
            requiredFields: ['appId', 'module'],
            eventType: enums_1.EventType.Log,
            url: loggingEndpoint,
            minLogLevel: enums_1.LogLevel.All
        };
        this.loggerTimber = new timber_1.Timber(config);
    }
    ///write to log
    TimberService.prototype.trace = function (message, parameters) { this.loggerTimber.trace(message, parameters); };
    TimberService.prototype.debug = function (message, parameters) { this.loggerTimber.debug(message, parameters); };
    TimberService.prototype.info = function (message, parameters) { this.loggerTimber.info(message, parameters); };
    TimberService.prototype.warn = function (message, parameters) { this.loggerTimber.warn(message, parameters); };
    TimberService.prototype.error = function (message, parameters) { this.loggerTimber.error(message, parameters); };
    TimberService.prototype.fatal = function (message, parameters) { this.loggerTimber.fatal(message, parameters); };
    return TimberService;
}());
exports.TimberService = TimberService;
